import { z } from "zod";

// Zod probes `new Function("")` to decide whether it may compile schemas. The production CSP
// has no 'unsafe-eval', so the probe is blocked and the browser logs a CSP violation on every
// page load. Turning the compiler off skips the probe; parsing behaves the same.
z.config({ jitless: true });
